import { TrendingUp } from "lucide-react";

export function ClientTimelineTab({ clientTimeline, timelineFilter, setTimelineFilter }) {
  const filtered = timelineFilter === "all" ? clientTimeline : clientTimeline.filter(e => e.phase === timelineFilter);

  return (
    <div className="bg-[#14101c] border border-white/10 rounded-xl p-6" data-testid="client-timeline-tab">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div>
          <h3 className="text-lg font-bold" style={{ color: "#f7c935" }}>Parcours client</h3>
          <p className="text-xs text-slate-500">Historique complet: prospection, CRM, prestations, facturation, documents</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {[
            { key: "all", label: "Tout", color: "#f7c935" },
            { key: "prospect", label: "Prospect", color: "#64748b" },
            { key: "crm", label: "CRM", color: "#22c55e" },
            { key: "prestation", label: "Prestations", color: "#8b5cf6" },
            { key: "facturation", label: "Facturation", color: "#3b82f6" },
            { key: "documents", label: "Documents", color: "#06b6d4" },
            { key: "suivi", label: "Notes", color: "#f59e0b" },
            { key: "securite", label: "Connexions", color: "#ef4444" },
          ].map(f => (
            <button key={f.key} onClick={() => setTimelineFilter(f.key)} data-testid={`timeline-filter-${f.key}`}
              className={`text-[10px] px-2 py-1 rounded-full font-medium transition-colors ${timelineFilter === f.key ? "ring-1 ring-white/20" : "opacity-60 hover:opacity-100"}`}
              style={{ background: f.color + "20", color: f.color }}>
              {f.label}
            </button>
          ))}
        </div>
      </div>
      {filtered.length === 0 ? (
        <div className="text-center py-12 text-slate-500">
          <TrendingUp className="w-10 h-10 mx-auto mb-3 text-slate-600" />
          <p className="text-sm">Aucun historique disponible</p>
          <p className="text-xs mt-1">Les evenements apparaitront au fil des interactions</p>
        </div>
      ) : (
        <div className="space-y-1 max-h-[500px] overflow-y-auto pr-1">
          {filtered.map((event, idx) => {
            const typeConfig = {
              note: { color: "#f59e0b", label: "Note" },
              call: { color: "#22c55e", label: "Appel" },
              email: { color: "#8b5cf6", label: "Email" },
              sms: { color: "#06b6d4", label: "SMS" },
              status_change: { color: "#f59e0b", label: "Statut" },
              conversion: { color: "#22c55e", label: "Conversion" },
              import: { color: "#64748b", label: "Import" },
              creation: { color: "#f7c935", label: "Creation" },
              opportunity: { color: "#22c55e", label: "Opportunite" },
              accompaniment: { color: "#8b5cf6", label: "Accompagnement" },
              service: { color: "#3b82f6", label: "Service" },
              invoice: { color: "#3b82f6", label: "Facture" },
              payment: { color: "#22c55e", label: "Paiement" },
              relance: { color: "#ef4444", label: "Relance" },
              document: { color: "#06b6d4", label: "Document" },
              login: { color: "#ef4444", label: "Connexion" },
            };
            const tc = typeConfig[event.type] || typeConfig.note;
            const phaseMap = { prospect: "Prospect", crm: "CRM", prestation: "Prestation", facturation: "Facturation", documents: "Documents", suivi: "Suivi", securite: "Securite", client: "Client" };
            const phaseLabel = phaseMap[event.phase] || "";
            return (
              <div key={`${event.entity_id}-${idx}`} className="flex gap-3 items-start group" data-testid={`timeline-event-${idx}`}>
                <div className="flex flex-col items-center pt-1">
                  <div className="w-2.5 h-2.5 rounded-full flex-shrink-0 ring-2 ring-[#14101c]" style={{ background: tc.color }} />
                  {idx < filtered.length - 1 && <div className="w-0.5 flex-1 min-h-[24px] bg-white/[0.04] mt-0.5" />}
                </div>
                <div className="flex-1 pb-2 -mt-0.5">
                  <div className="flex items-center gap-1.5 mb-0.5 flex-wrap">
                    <span className="text-[9px] px-1.5 py-0.5 rounded font-bold uppercase tracking-wider" style={{ background: tc.color + "18", color: tc.color }}>{tc.label}</span>
                    <span className="text-[9px] px-1.5 py-0.5 rounded bg-white/5 text-slate-500">{phaseLabel}</span>
                    {event.opp_title && <span className="text-[9px] text-slate-600 italic">{event.opp_title}</span>}
                    {event.by_name && <span className="text-[9px] text-slate-600">par {event.by_name}</span>}
                    <span className="text-[9px] text-slate-700 ml-auto">{event.at ? new Date(event.at).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : ""}</span>
                  </div>
                  <p className="text-xs text-slate-300 leading-relaxed">{event.content || event.subject || `${event.from_status || ""} \u2192 ${event.to_status || ""}`}</p>
                  {event.duration && <span className="text-[9px] text-slate-600 mt-0.5 inline-block">Duree: {event.duration}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="mt-3 text-[10px] text-slate-600 text-center">{clientTimeline.length} evenement{clientTimeline.length > 1 ? "s" : ""} au total</div>
    </div>
  );
}
